import { render, staticRenderFns } from "./productModalFullscreen.vue?vue&type=template&id=a496020c"
import script from "./productModalFullscreen.vue?vue&type=script&lang=js"
export * from "./productModalFullscreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports